/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/idv';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveIdvStatusRequest": {
                    "fields": {
                      "storeCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveIdvStatusResponse": {
                    "fields": {
                      "status": {
                        "type": "squareup.solidshop.v2.resources.IdvStatus",
                        "id": 1,
                        "rule": "optional"
                      },
                      "accountOwner": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "gpv365dBelowThreshold": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "whitelisted": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE RetrieveIdvStatusRequest @ squareup/solidshop/v2/service/idv/retrieve_idv_status.proto at 12:1
 */
export const RetrieveIdvStatusRequest = $root.lookupType('squareup.solidshop.v2.service.RetrieveIdvStatusRequest');
fixType(RetrieveIdvStatusRequest, {
  storeCode: { required: true },
});
Builder.createAndAttachToType(RetrieveIdvStatusRequest);
/**
 * SOURCE RetrieveIdvStatusResponse @ squareup/solidshop/v2/service/idv/retrieve_idv_status.proto at 17:1
 */
export const RetrieveIdvStatusResponse = $root.lookupType('squareup.solidshop.v2.service.RetrieveIdvStatusResponse');
fixType(RetrieveIdvStatusResponse);
Builder.createAndAttachToType(RetrieveIdvStatusResponse);
